import { ArrowRight } from "lucide-react";

const ChiappellaHero = () => {
  const handleScroll = () => {
    const el = document.getElementById("momento");
    if (el) el.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        background:
          "linear-gradient(180deg, hsl(220 69% 3%), hsl(215 55% 10%))",
      }}
    >
      {/* Overlay radial azul sutil centrado */}
      <div
        className="pointer-events-none absolute inset-0"
        style={{
          background:
            "radial-gradient(ellipse at center, rgba(91,163,224,0.18) 0%, rgba(29,74,140,0.08) 35%, transparent 70%)",
        }}
        aria-hidden="true"
      />

      <div className="relative z-10 max-w-5xl mx-auto px-6 py-24 text-center">
        {/* Badge superior */}
        <div className="inline-flex items-center px-4 py-2 mb-10 rounded-full border border-white/10 bg-white/5 backdrop-blur-sm">
          <span className="text-[11px] md:text-xs tracking-[0.25em] uppercase text-white/70 font-medium">
            Propuesta exclusiva · Marca personal · Gastón Parada
          </span>
        </div>

        {/* Título principal */}
        <h1 className="font-display text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-[1.05] mb-8">
          Hay un lugar
          <br />
          que nadie ocupa.
          <br />
          Y vos ya sabés
          <br />
          <span style={{ color: "#5BA3E0" }}>por qué es tuyo.</span>
        </h1>

        {/* Subtítulo */}
        <p className="max-w-2xl mx-auto text-base md:text-lg text-white/75 leading-relaxed mb-10">
          Todos hablan de la Macro. Nadie habla de la calle. Construyamos la
          autoridad que convierte a la pyme en tu mercado y a vos en su
          referente.
        </p>

        {/* Badge de vigencia */}
        <div className="inline-flex items-center px-4 py-2 mb-10 rounded-full border border-white/10 bg-white/5">
          <span className="text-xs md:text-sm text-white/70">
            Esta propuesta tiene validez de 7 días hábiles desde su presentación.
          </span>
        </div>

        {/* CTA */}
        <div>
          <button
            onClick={handleScroll}
            className="group inline-flex items-center gap-3 px-8 py-4 rounded-full text-base md:text-lg font-medium text-white transition-all duration-300 hover:scale-[1.02]"
            style={{
              background: "linear-gradient(135deg, #1d4a8c 0%, #3B8BD4 100%)",
              boxShadow: "0 10px 40px -10px rgba(59,139,212,0.5)",
            }}
          >
            Ver la propuesta
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </button>
        </div>
      </div>
    </section>
  );
};

export default ChiappellaHero;
